import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

// Cart quantity clicks are handled here exactly once; cart markup omits inline handlers.

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  connectedCallback() {
    super.connectedCallback();

    if (this._varelNativeControlsBound) return;
    this._varelNativeControlsBound = true;

    // La hidratación puede reemplazar los botones internos. El evento vive en
    // el componente estable y por eso sobrevive a cualquier actualización.
    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('button[name="minus"], button[name="plus"]');
      if (!button || !this.contains(button) || button.disabled) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.updateQuantity(button.name === 'plus' ? 1 : -1);
    }, true);

    this.addEventListener('blur', (event) => {
      if (!(event.target instanceof HTMLInputElement) || event.target !== this.refs.quantityInput) return;
      event.stopImmediatePropagation();
      this.setQuantity(event);
    }, true);
  }

  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    // Cart buttons are always dynamically managed
    minusButton.disabled = value <= min;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
